/**
 * @generated SignedSource<<5c53c12c226088e49ca312a6bd0257c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPageFragment$data = {
  readonly internalId: string | null | undefined;
  readonly " $fragmentType": "ProjectPageFragment";
};
export type ProjectPageFragment$key = {
  readonly " $data"?: ProjectPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalId",
      "storageKey": null
    }
  ],
  "type": "ProjectRest",
  "abstractKey": null
};

(node as any).hash = "cb28258810c139e0b9f5e24485d15b96";

export default node;
